import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import KeyNumbers from './components/KeyNumbers';
import VisionSection from './components/VisionSection';
import CourtsSection from './components/CourtsSection';
import ActivitiesSection from './components/ActivitiesSection';
import PricingSection from './components/PricingSection';
import AppSection from './components/AppSection';
import NewsSection from './components/NewSection';
import GallerySection from './components/GallerySection';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <KeyNumbers />
      <VisionSection />
      <CourtsSection />
      <ActivitiesSection />
      <PricingSection />
      <AppSection />
      <NewsSection />
      <GallerySection />
      <Footer />
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/237687696969"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:bg-[#22c55e] transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Contact WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
      </a>
    </main>
  );
}